import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaQuestionCircle, FaHome, FaChevronDown, FaChevronUp, FaSearch, FaTrophy, FaShoppingCart, FaGamepad, FaCog } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import Navbar from '../components/Layout/Navbar';
import TopBar from '../components/Layout/TopBar';

const FAQ = () => {
  const [openItems, setOpenItems] = useState({});
  const [searchTerm, setSearchTerm] = useState('');

  const faqData = [
    {
      category: "Général",
      icon: FaHome,
      color: "from-[#001B56] to-[#0d47a1]",
      items: [
        {
          id: 1,
          question: "Qu'est-ce que l'EFAFC ?",
          answer: "L'Entente Feignies Aulnoye Football Club (EFAFC) est un club de football situé dans le Nord de la France. Le club évolue en National 2 et propose également des équipes de jeunes et féminines."
        },
        {
          id: 2,
          question: "Comment puis-je rejoindre le club ?",
          answer: "Pour rejoindre l'EFAFC, vous pouvez nous contacter directement par email à contact@efafc.fr ou vous rendre au stade lors des entraînements. Les inscriptions se font généralement en début de saison."
        },
        {
          id: 3,
          question: "Où se trouve le stade ?",
          answer: "Notre stade principal est le Stade Didier Eloy, situé à Feignies. L'adresse exacte et les informations d'accès sont disponibles sur notre site."
        }
      ]
    },
    {
      category: "Fan Zone",
      icon: FaGamepad,
      color: "from-[#BDFF00] to-[#a4e600]",
      items: [
        {
          id: 4,
          question: "Comment accéder à la Fan Zone ?",
          answer: "Pour accéder à la Fan Zone, vous devez créer un compte utilisateur sur notre site. Une fois connecté, vous pourrez participer à tous les jeux et activités proposés."
        },
        {
          id: 5,
          question: "Comment gagner des badges ?",
          answer: "Les badges se gagnent en participant aux différentes activités de la Fan Zone : réussir des quiz, jouer aux jeux, participer au mur des supporters, etc. Chaque activité peut débloquer des badges spécifiques."
        },
        {
          id: 6,
          question: "Que sont les points et à quoi servent-ils ?",
          answer: "Les points s'accumulent en participant aux activités de la Fan Zone. Ils permettent de vous classer dans le leaderboard et peuvent parfois être utilisés pour débloquer du contenu exclusif."
        },
        {
          id: 7,
          question: "Comment fonctionne le système de pronostics ?",
          answer: "Le système de pronostics vous permet de prédire les résultats des matchs de toutes nos équipes. Plus vos pronostics sont précis, plus vous gagnez de points !"
        }
      ]
    },
    {
      category: "Boutique",
      icon: FaShoppingCart,
      color: "from-[#FFE400] to-[#f4d03f]",
      items: [
        {
          id: 8,
          question: "Comment passer une commande ?",
          answer: "Pour passer commande, ajoutez les articles souhaités à votre panier, puis suivez le processus de commande. Vous devez être connecté pour finaliser un achat."
        },
        {
          id: 9,
          question: "Quels sont les moyens de paiement acceptés ?",
          answer: "Actuellement, la boutique fonctionne en mode fictif pour démonstration. Dans une version réelle, nous accepterions les cartes bancaires et PayPal."
        },
        {
          id: 10,
          question: "Puis-je retourner un article ?",
          answer: "Oui, vous disposez d'un droit de rétractation de 14 jours selon la législation en vigueur. Les conditions de retour détaillées sont disponibles dans nos CGV."
        },
        {
          id: 11,
          question: "Les tailles correspondent-elles aux standards ?",
          answer: "Nos maillots suivent les tailles standards européennes. Un guide des tailles est disponible sur chaque fiche produit pour vous aider à choisir."
        }
      ]
    },
    {
      category: "Compte et données",
      icon: FaCog,
      color: "from-[#001B56] to-[#2c3e50]",
      items: [
        {
          id: 12,
          question: "Comment modifier mes informations personnelles ?",
          answer: "Vous pouvez modifier vos informations en vous rendant dans votre profil Fan Zone. Cliquez sur 'Modifier le profil' pour accéder aux paramètres."
        },
        {
          id: 13,
          question: "Comment supprimer mon compte ?",
          answer: "Pour supprimer votre compte, contactez-nous à contact@efafc.fr. Nous traiterons votre demande conformément au RGPD dans les plus brefs délais."
        },
        {
          id: 14,
          question: "Mes données sont-elles sécurisées ?",
          answer: "Oui, nous prenons la sécurité de vos données très au sérieux. Consultez notre page RGPD pour plus d'informations sur la protection de vos données personnelles."
        }
      ]
    },
    {
      category: "Technique",
      icon: FaCog,
      color: "from-slate-600 to-slate-800",
      items: [
        {
          id: 15,
          question: "Le site ne fonctionne pas correctement, que faire ?",
          answer: "Essayez d'abord de vider le cache de votre navigateur et de recharger la page. Si le problème persiste, contactez-nous en décrivant précisément le dysfonctionnement."
        },
        {
          id: 16,
          question: "Le site est-il compatible avec mobile ?",
          answer: "Oui, notre site est entièrement responsive et optimisé pour les appareils mobiles et tablettes."
        },
        {
          id: 17,
          question: "Puis-je recevoir des notifications ?",
          answer: "Oui, vous pouvez activer les notifications pour être informé des nouveaux badges, résultats de matchs, et autres actualités du club."
        }
      ]
    }
  ];

  const toggleItem = (id) => {
    setOpenItems(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const filteredFAQ = faqData.map(category => ({
    ...category,
    items: category.items.filter(item =>
      item.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.answer.toLowerCase().includes(searchTerm.toLowerCase())
    )
  })).filter(category => category.items.length > 0);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#001B56] via-[#001d5a] to-[#002766]">
      <TopBar />
      <div className="sticky top-4 z-50 flex flex-col items-center w-full">
        <div className="relative w-[90vw] max-w-2xl">
          <Navbar />
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 pt-24 pb-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-12 text-center"
        >
          <div className="flex items-center justify-center gap-4 mb-6">
            <motion.div
              initial={{ scale: 0, rotate: -180 }}
              animate={{ scale: 1, rotate: 0 }}
              transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
              className="p-4 bg-gradient-to-br from-[#FFE400] to-[#f4d03f] rounded-full shadow-xl"
            >
              <FaQuestionCircle className="text-4xl text-[#001B56]" />
            </motion.div>
            <div>
              <h1 className="text-5xl font-extrabold text-white mb-2 bg-gradient-to-r from-[#FFE400] to-[#BDFF00] bg-clip-text text-transparent">
                FAQ EFAFC
              </h1>
              <p className="text-[#BDFF00]/80 text-lg font-medium">
                Toutes les réponses à vos questions sur l'Entente
              </p>
            </div>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="relative max-w-2xl mx-auto"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-[#FFE400] to-[#BDFF00] rounded-2xl blur opacity-20"></div>
            <div className="relative bg-white/10 backdrop-blur-md rounded-2xl border border-white/20 shadow-2xl">
              <FaSearch className="absolute left-6 top-1/2 transform -translate-y-1/2 text-[#BDFF00] text-xl" />
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Recherchez votre question..."
                className="w-full pl-16 pr-6 py-5 bg-transparent text-white placeholder-white/60 focus:outline-none text-lg font-medium"
              />
            </div>
          </motion.div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12"
        >
          <div className="relative group">
            <div className="absolute inset-0 bg-gradient-to-br from-[#FFE400] to-[#f4d03f] rounded-2xl blur opacity-20 group-hover:opacity-40 transition-opacity"></div>
            <div className="relative bg-white/10 backdrop-blur-md rounded-2xl p-6 text-center border border-white/20 shadow-lg">
              <div className="text-3xl font-bold text-[#FFE400] mb-1">
                {faqData.reduce((acc, cat) => acc + cat.items.length, 0)}
              </div>
              <div className="text-white/80 font-medium">Questions</div>
            </div>
          </div>
          
          <div className="relative group">
            <div className="absolute inset-0 bg-gradient-to-br from-[#BDFF00] to-[#a4e600] rounded-2xl blur opacity-20 group-hover:opacity-40 transition-opacity"></div>
            <div className="relative bg-white/10 backdrop-blur-md rounded-2xl p-6 text-center border border-white/20 shadow-lg">
              <div className="text-3xl font-bold text-[#BDFF00] mb-1">{faqData.length}</div>
              <div className="text-white/80 font-medium">Catégories</div>
            </div>
          </div>
          
          <div className="relative group">
            <div className="absolute inset-0 bg-gradient-to-br from-[#FFE400] to-[#BDFF00] rounded-2xl blur opacity-20 group-hover:opacity-40 transition-opacity"></div>
            <div className="relative bg-white/10 backdrop-blur-md rounded-2xl p-6 text-center border border-white/20 shadow-lg">
              <div className="text-3xl font-bold text-[#FFE400] mb-1">24/7</div>
              <div className="text-white/80 font-medium">Disponible</div>
            </div>
          </div>
          
          <div className="relative group">
            <div className="absolute inset-0 bg-gradient-to-br from-[#BDFF00] to-[#FFE400] rounded-2xl blur opacity-20 group-hover:opacity-40 transition-opacity"></div>
            <div className="relative bg-white/10 backdrop-blur-md rounded-2xl p-6 text-center border border-white/20 shadow-lg">
              <div className="text-3xl font-bold text-[#BDFF00] mb-1">⚡</div>
              <div className="text-white/80 font-medium">Réponse rapide</div>
            </div>
          </div>
        </motion.div>

        <div className="space-y-8">
          {filteredFAQ.length === 0 ? (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="text-center py-16"
            >
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-br from-[#FFE400] to-[#BDFF00] rounded-full blur opacity-20"></div>
                <div className="relative bg-white/10 backdrop-blur-md rounded-full p-8 inline-block border border-white/20">
                  <FaQuestionCircle className="text-6xl text-[#BDFF00]" />
                </div>
              </div>
              <h3 className="text-2xl font-bold text-white mt-6 mb-3">Aucun résultat trouvé</h3>
              <p className="text-white/70 text-lg">Essayez avec d'autres mots-clés ou contactez-nous directement.</p>
            </motion.div>
          ) : (
            filteredFAQ.map((category, categoryIndex) => {
              const IconComponent = category.icon;
              return (
                <motion.div
                  key={category.category}
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: categoryIndex * 0.1 + 0.5 }}
                  className="relative group"
                >
                  <div className={`absolute inset-0 bg-gradient-to-r ${category.color} rounded-3xl blur opacity-10 group-hover:opacity-20 transition-opacity`}></div>
                  
                  <div className="relative bg-white/5 backdrop-blur-md rounded-3xl border border-white/10 shadow-2xl overflow-hidden">
                    <div className={`bg-gradient-to-r ${category.color} p-6`}>
                      <div className="flex items-center gap-4">
                        <div className="p-3 bg-white/20 rounded-xl backdrop-blur-sm">
                          <IconComponent className="text-2xl text-white" />
                        </div>
                        <h2 className="text-2xl font-bold text-white">{category.category}</h2>
                      </div>
                    </div>
                    
                    <div className="divide-y divide-white/10">
                      {category.items.map((item, itemIndex) => (
                        <motion.div
                          key={item.id}
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                          transition={{ delay: (categoryIndex * 0.1) + (itemIndex * 0.05) + 0.6 }}
                        >
                          <button
                            onClick={() => toggleItem(item.id)}
                            className="w-full px-8 py-6 text-left hover:bg-white/5 transition-all duration-300 focus:outline-none focus:bg-white/5 group/item"
                          >
                            <div className="flex items-center justify-between">
                              <h3 className="font-semibold text-white text-lg pr-4 group-hover/item:text-[#BDFF00] transition-colors">
                                {item.question}
                              </h3>
                              <motion.div
                                animate={{ rotate: openItems[item.id] ? 180 : 0 }}
                                transition={{ duration: 0.3 }}
                              >
                                {openItems[item.id] ? (
                                  <FaChevronUp className="text-[#BDFF00] flex-shrink-0 text-lg" />
                                ) : (
                                  <FaChevronDown className="text-white/60 flex-shrink-0 text-lg group-hover/item:text-[#BDFF00] transition-colors" />
                                )}
                              </motion.div>
                            </div>
                          </button>
                          
                          <AnimatePresence>
                            {openItems[item.id] && (
                              <motion.div
                                initial={{ height: 0, opacity: 0 }}
                                animate={{ height: 'auto', opacity: 1 }}
                                exit={{ height: 0, opacity: 0 }}
                                transition={{ duration: 0.4, ease: "easeInOut" }}
                                className="overflow-hidden"
                              >
                                <div className="px-8 pb-6">
                                  <div className="bg-white/5 rounded-xl p-6 border border-white/10">
                                    <p className="text-white/90 leading-relaxed text-lg">{item.answer}</p>
                                  </div>
                                </div>
                              </motion.div>
                            )}
                          </AnimatePresence>
                        </motion.div>
                      ))}
                    </div>
                  </div>
                </motion.div>
              );
            })
          )}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8 }}
          className="mt-16 relative group"
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#FFE400] to-[#BDFF00] rounded-3xl blur opacity-20 group-hover:opacity-30 transition-opacity"></div>
          <div className="relative bg-white/10 backdrop-blur-md rounded-3xl p-10 text-center border border-white/20 shadow-2xl">
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 1, type: "spring", stiffness: 200 }}
              className="inline-block p-4 bg-gradient-to-br from-[#FFE400] to-[#BDFF00] rounded-full mb-6"
            >
              <FaQuestionCircle className="text-3xl text-[#001B56]" />
            </motion.div>
            
            <h3 className="text-3xl font-bold text-white mb-4">Vous ne trouvez pas votre réponse ?</h3>
            <p className="mb-8 text-white/80 text-lg max-w-2xl mx-auto">
              Notre équipe EFAFC est là pour vous aider ! N'hésitez pas à nous contacter directement pour toute question supplémentaire.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              <motion.a
                href="mailto:contact@efafc.fr"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-[#FFE400] to-[#BDFF00] text-[#001B56] rounded-xl hover:shadow-lg transition-all duration-300 font-bold text-lg"
              >
                📧 contact@efafc.fr
              </motion.a>
              
              <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                <Link
                  to="/"
                  className="inline-flex items-center justify-center gap-3 px-8 py-4 border-2 border-[#BDFF00] text-[#BDFF00] rounded-xl hover:bg-[#BDFF00] hover:text-[#001B56] transition-all duration-300 font-bold text-lg"
                >
                  <FaHome />
                  Retour à l'accueil
                </Link>
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;